import { Center, Stack, Text } from '@chakra-ui/react';

export function VoucherEmptyState() {
  return (
    <Center
      border="1px dashed"
      borderColor="gray.300"
      borderRadius="lg"
      py={12}
      bg="gray.50"
    >
      <Stack spacing={2} align="center">
        <Text fontSize="lg" fontWeight="semibold" color="gray.700">
          Belum ada voucher yang ditampilkan
        </Text>
        <Text fontSize="sm" color="gray.500" textAlign="center">
          Gunakan tombol "+ Voucher Baru" untuk membuat voucher atau ubah filter
          pencarian Anda.
        </Text>
      </Stack>
    </Center>
  );
}
